export default function swap([A, B]) {
	return [B, A];
}
